import FbButton from 'components/FbUI/FbButton'
import { cn } from 'components/UI/cn'
import { useCallback, useEffect, useRef, useState } from 'react'
import { PiMagnifyingGlass, PiPencilSimpleLine } from 'react-icons/pi'

interface InboxSearchBarProps {
  value: string
  onChange: (value: string) => void
  onCompose?: () => void
}

/** Debounced search input with a Compose button. */
export function InboxSearchBar({
  value,
  onChange,
  onCompose,
}: InboxSearchBarProps) {
  const [localValue, setLocalValue] = useState(value)
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value
      setLocalValue(newValue)
      clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        onChange(newValue)
      }, 300)
    },
    [onChange]
  )

  useEffect(() => {
    return () => clearTimeout(timerRef.current)
  }, [])

  return (
    <div className="flex items-center gap-2.5">
      <div className="relative flex-1">
        <PiMagnifyingGlass className="absolute left-4 top-1/2 -translate-y-1/2 size-[22px] text-[#6E6E6E]" />
        <input
          type="text"
          value={localValue}
          onChange={handleChange}
          placeholder="Search mail by company name, domain, sender"
          className={cn(
            'w-full pl-11 pr-3 h-[40px] text-base rounded-lg border border-[#E2E2E2]',
            'placeholder:text-[#6E6E6E] focus:outline-none focus:border-[#06512f] focus:ring-1 focus:ring-[#06512f]'
          )}
        />
      </div>
      <FbButton
        variant="primary"
        disabled={!onCompose}
        onClick={onCompose}
        className="h-[40px] px-2 gap-2"
      >
        <PiPencilSimpleLine className="size-[22px]" />
        <span className="text-base font-medium">Compose</span>
      </FbButton>
    </div>
  )
}
